import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActiveRoutesDetail, ServiceExpense } from '../../pages/active-routes/components/active-routes-detail/interfaces/ActiveRoutesDetail.interface';
import { GetValuesService } from 'src/app/core/services/get-values.service';

const EXPENSE_CATEGORY_PREFIX = 'expenses.category.';

@Component({
    selector: 'app-report-content',
    templateUrl: './report-content.component.html',
    styleUrls: ['./report-content.component.scss']
})
export class ReportContentComponent {
    @Output() download = new EventEmitter<void>();
    @Input() details!: ActiveRoutesDetail;
    @Input() brandingLogo?: string;
    @Input() isEconomicReport: boolean = false;
    @Input() showPDF: boolean = false;
    @Input() paginatedPickupImages: string[][] = [];
    @Input() paginatedDropoffImages: string[][] = [];
    @Input() orderHash?: string | null;

    constructor(private getValuesService: GetValuesService, private translate: TranslateService) { }

    getVehicleIcon(id: number | undefined): string {
        if (!id) { return '' }
        return this.getValuesService.getChassisTypeIcon(id);
    }

    getFuelType(id?: number): string {
        if (!id) return 'Desconocido';
        return this.getValuesService.getFuelTypeString(id);
    }

    getChassisType(id?: number): string {
        if (!id) return 'Desconocido';
        return this.getValuesService.getChassisTypeString(id);
    }

    get expenseReceipts(): string[] {
        return (this.details?.FinancialInformation?.Expenses ?? [])
            .map((expense) => expense.ReceiptUrl)
            .filter((url): url is string => !!url);
    }

    expenseLabel(expense: ServiceExpense): string {
        const category = this.categoryLabel(expense.Category);

        if (!expense.Description) { return category; }

        return category ? `${category} · ${expense.Description}` : expense.Description;
    }

    private categoryLabel(category?: string): string {
        if (!category) { return ''; }

        const key = `${EXPENSE_CATEGORY_PREFIX}${category}`;
        const translated = this.translate.instant(key);

        // Sin literal, ngx-translate devuelve la clave: se escribe el slug tal cual
        // antes que dejar la línea del informe sin explicar.
        return translated === key ? category : translated;
    }
}
